<CustomWizardComposerEditor
  @field={{this.field}}
  @composer={{this.composer}}
  @wizard={{this.wizard}}
  @fieldClass={{this.fieldClass}}
  @groupsMentioned={{this.groupsMentioned}}
  @cannotSeeMention={{this.cannotSeeMention}}
  @importQuote={{this.importQuote}}
  @togglePreview={{this.togglePreview}}
  @afterRefresh={{this.afterRefresh}}
/>

<div class="bottom-bar">
  <DButton
    @action={{this.togglePreview}}
    class="wizard-btn toggle-preview"
    @label={{this.togglePreviewLabel}}
  />

  {{#if this.field.char_counter}}
    {{wizard-char-counter this.field.value this.field.max_length}}
  {{/if}}
</div>